//
//  SDKCustomDomainErrorCode.ts
//  Supernova SDK
//
//  Created by Fiki Sulik.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - custom domain error code enum
export var CustomDomainErrorCode;
(function (CustomDomainErrorCode) {
    CustomDomainErrorCode["generalError"] = "GeneralError";
    CustomDomainErrorCode["dnsNotConfigured"] = "DNSNotConfigured";
    CustomDomainErrorCode["maintenance"] = "Maintenance";
})(CustomDomainErrorCode || (CustomDomainErrorCode = {}));
